import React from 'react';
import { FormattedMessage } from 'react-intl';

import styles from './Notifications-style.scss';

const NotificationsEmpty = () => {
    return (
        <div className={styles.emptyContainer}>
            <p>
                <FormattedMessage
                    id='dbl.Header.Notifications.empty_content'
                    defaultMessage="We'll notify you of new and unread messages here!"
                />
            </p>
        </div>
    );
};

export default NotificationsEmpty;



// WEBPACK FOOTER //
// ./src/components/Notifications/NotificationsEmpty.jsx